/**
 * Filter Grid Fix (Safety Net)
 *
 * Fallback for when the theme's morph algorithm fails to update the product
 * grid after filter changes. Detects stale grids and force-updates them.
 * This is a safety net — the primary fix is in section-renderer.js.
 */
(function() {
  var pendingUpdate = null;
  var gridSnapshotId = null;
  var gridSnapshotCount = 0;

  var origPushState = history.pushState;
  history.pushState = function() {
    // Capture grid state BEFORE the URL changes
    var grid = document.querySelector('[ref="grid"]');
    if (grid) {
      var first = grid.querySelector('[data-product-id]');
      gridSnapshotId = first ? first.dataset.productId : null;
      gridSnapshotCount = grid.querySelectorAll('[data-product-id]').length;
    }

    origPushState.apply(this, arguments);

    if (pendingUpdate) clearTimeout(pendingUpdate);
    pendingUpdate = setTimeout(checkAndFixGrid, 1000);
  };

  window.addEventListener('popstate', function() {
    var grid = document.querySelector('[ref="grid"]');
    if (grid) {
      var first = grid.querySelector('[data-product-id]');
      gridSnapshotId = first ? first.dataset.productId : null;
      gridSnapshotCount = grid.querySelectorAll('[data-product-id]').length;
    }
    if (pendingUpdate) clearTimeout(pendingUpdate);
    pendingUpdate = setTimeout(checkAndFixGrid, 1000);
  });

  function checkAndFixGrid() {
    pendingUpdate = null;

    // Check if the grid actually changed from the snapshot
    var grid = document.querySelector('[ref="grid"]');
    if (!grid) return;

    var first = grid.querySelector('[data-product-id]');
    var currentId = first ? first.dataset.productId : null;
    var currentCount = grid.querySelectorAll('[data-product-id]').length;

    // If grid changed (morph or section-renderer fix worked), nothing to do
    if (currentId !== gridSnapshotId || currentCount !== gridSnapshotCount) return;

    // Grid didn't change — the morph failed. Fetch and force-update.
    var sectionEl = document.querySelector('[id^="shopify-section-"][id$="__main"]');
    if (!sectionEl) return;

    var sectionId = sectionEl.id.replace('shopify-section-', '');
    var fetchUrl = new URL(location.href);
    fetchUrl.searchParams.set('section_id', sectionId);
    fetchUrl.searchParams.sort();

    fetch(fetchUrl.toString())
      .then(function(r) { return r.text(); })
      .then(function(html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var newGrid = doc.querySelector('[ref="grid"]');
        var oldGrid = document.querySelector('[ref="grid"]');

        if (newGrid && oldGrid) {
          oldGrid.innerHTML = newGrid.innerHTML;
          for (var i = 0; i < newGrid.attributes.length; i++) {
            var attr = newGrid.attributes[i];
            oldGrid.setAttribute(attr.name, attr.value);
          }
        } else if (!newGrid && oldGrid) {
          var newContainer = doc.querySelector('#ResultsList');
          var oldContainer = document.querySelector('#ResultsList');
          if (newContainer && oldContainer) {
            oldContainer.innerHTML = newContainer.innerHTML;
          }
        }
      })
      .catch(function() {});
  }
})();
